import { openDB } from 'idb';

export default class IndexedDBHelperV2 {
    constructor(dbName, version = 1, storeConfigs = []) {
        this.dbName = dbName;
        this.version = version;
        this.storeConfigs = storeConfigs; // Array of store configurations
        this.dbPromise = this.initDB();
    }

    async initDB() {
        return openDB(this.dbName, this.version, {
            upgrade: (db, oldVersion, newVersion, transaction) => {
                for (const config of this.storeConfigs) {
                    const { storeName, keyPath, indexes = [] } = config;

                    // Create the store if it doesn't exist
                    if (!db.objectStoreNames.contains(storeName)) {
                        const store = db.createObjectStore(storeName, { keyPath });

                        // Add each index for the store
                        for (const { indexName, keyPath, options = {} } of indexes) {
                            store.createIndex(indexName, keyPath, options);
                        }
                    } else { // updated store with new index
                        // Handle existing stores: add missing indexes
                        const store = transaction.objectStore(storeName);

                        // Add missing indexes
                        for (const { indexName, keyPath, options = {} } of indexes) {
                            if (!store.indexNames.contains(indexName)) {
                                store.createIndex(indexName, keyPath, options);
                                console.log(`Index added to existing store: ${indexName}`);
                            }
                        }
                    }
                }
            },
        });
    }

    async addData(storeName, data) {
        const db = await this.dbPromise;
        return db.add(storeName, data);
    }


    // If one fails with Primary key already exists, then new record will not be inserted all will be failed

    async addBulkData(storeName, dataArray) {
        const db = await this.dbPromise;
        const transaction = db.transaction(storeName, 'readwrite');

        try {
            for (const data of dataArray) {
                await transaction.store.add(data);
            }
            await transaction.done;
            console.log("All data added successfully to store:", storeName);
        } catch (error) {
            console.error(`Error adding bulk data to store ${storeName}:`, error);
        }
    }


    // If the Primary Key already Exists then updates otherwise insert the document

    async updateBulkData(storeName, dataArray) {
        const db = await this.dbPromise;
        const transaction = db.transaction(storeName, 'readwrite');

        const results = [];
        const errors = [];

        for (const data of dataArray) {
            try {
                const result = await transaction.store.put(data); // Use put instead of add
                // results.push(result);
            } catch (error) {
                // console.error(`Error adding/updating record: ${error}`);
                // errors.push(`Error adding/updating record: ${error}`);
            }
        }

        await transaction.done; // Wait for the transaction to complete

        // console.log("Results:", results);
        // console.log("Errors:", errors);
    }

    async getAllByIds(storeName, ids) {
        const db = await this.dbPromise;
        const transaction = db.transaction(storeName, 'readonly');
        const store = transaction.objectStore(storeName);

        const results = [];

        for (const id of ids) {
            const record = await store.get(id);
            if (record) {
                results.push(record);
            }
        }

        await transaction.done; // Wait for the transaction to complete
        return results;
    }

    async getData(storeName, id) {
        const db = await this.dbPromise;
        return db.get(storeName, id);
    }

    async getAllData(storeName) {
        const db = await this.dbPromise;
        return db.getAll(storeName);
    }

    async getDataByIndexValue(storeName, indexName, indexValue) {
        const db = await this.dbPromise;
        return db.getAllFromIndex(storeName, indexName, indexValue);
    }

    // async updateData(storeName, data) {
    //     const db = await this.dbPromise;
    //     return db.put(storeName, data);
    // }

    async updateData(storeName, data) {
        console.log(storeName, data)
        const db = await this.dbPromise;
        const tx = db.transaction(storeName, "readwrite");
        const store = tx.objectStore(storeName);

        return store.put(data); // ✅ Correct usage
    }

    // Key Here is Primary Key only

    // async updateData(storeName, data, key) {
    //     const db = await this.dbPromise;
    //     const tx = db.transaction(storeName, "readwrite");
    //     const store = tx.objectStore(storeName);

    //     // If `data` contains the primary key, `key` is not needed
    //     const request = key ? store.put(data, key) : store.put(data);

    //     return new Promise((resolve, reject) => {
    //         request.onsuccess = () => resolve(true);
    //         request.onerror = () => reject(request.error);
    //     });
    // }

    async deleteData(storeName, id) {
        const db = await this.dbPromise;
        return db.delete(storeName, id);
    }

    async deleteBulkByIds(storeName, ids = []) {
        if (!ids.length) return;

        const db = await this.dbPromise;
        const tx = db.transaction(storeName, 'readwrite');
        const store = tx.objectStore(storeName);

        for (const id of ids) {
            await store.delete(id);
        }

        await tx.done;
        console.log(`Deleted ${ids.length} records from ${storeName}`);
    }

    async getAllFromIndex(storeName, indexName, value) {
        const db = await this.dbPromise;
        const tx = db.transaction(storeName, 'readonly');
        const index = tx.store.index(indexName);

        // Use the index's getAll method with the value
        const results = await index.getAll(value);

        return results; // Return all matching records
    }
}
